// extracted by mini-css-extract-plugin
export default {"illustrationContainer":"AuthConfirmPage_illustrationContainer__gmr0Y"};